import React from "react";
import "style/Contact.scss";

import { Col, Row, Container, Button } from "react-bootstrap";
import "bootstrap/dist/css/bootstrap.min.css";
import { Link } from "react-router-dom";

import ModalDropdown from "../components/ModalDropdown";

import { default as SvgHeaderTitle } from "assets/SvgHeaderTitle.svg";
import { default as SvgHeaderNavigation } from "assets/SvgHeaderNavigation.svg";
import { default as SvgHeaderNavigationClose } from "assets/SvgHeaderNavigationClose.svg";
import { default as SvgChangeLanguage } from "assets/icon_lang.svg";

import en from "../config/i18n/english/english";
import de from "../config/i18n/german/german";

interface Props {}

interface State {
  dropdown: boolean;
  language: any;
  dropdownLanguage: boolean;
}

class Imprint extends React.Component<Props, State> {
  constructor(props: Props) {
    super(props);
    this.state = {
      language: en,
      dropdown: false,
      dropdownLanguage: false,
    };
  }

  componentDidMount() {
    if (sessionStorage.getItem("lang") === null) {
      const browserLanguage = navigator.language.split("-")[0];
      this.setState({
        language: browserLanguage === "de" ? de : en,
      });
    } else {
      this.setState({
        language: sessionStorage.getItem("lang") === "de" ? de : en,
      });
    }

    window.addEventListener("scroll", (e) => this.handleScrollPositionEvent(e));

    return () => {
      window.removeEventListener("scroll", (e) =>
        this.handleScrollPositionEvent(e)
      );
    };
  }

  componentWillUnmount() {
    this.setState = (state, callback) => {
      return;
    };
  }

  handleScrollPositionEvent(e: any) {
    this.setState({ dropdownLanguage: false });
    this.setState({ dropdown: false });
  }

  render() {
    const { language } = this.state;
    return (
      <>
        <ModalDropdown
          showDropdown={this.state.dropdown}
          showDropdownLanguage={this.state.dropdownLanguage}
          imprint={this.state.dropdown}
        />

        <div className="header-contact">
          <Container
            fluid={true}
            className="p-0 container-title-dropdown container-logo-dropdown"
          >
            <Row className="g-0">
              <Col className="svg-header-title">
                <Link to="/">
                  <img
                    src={SvgHeaderTitle}
                    className="svgHeaderTitle"
                    alt="svg header"
                  />
                </Link>
              </Col>

              <Col className="dropdown text-end">
                <Button
                  onClick={() => {
                    this.setState({
                      dropdown: false,
                      dropdownLanguage: !this.state.dropdownLanguage,
                    });
                  }}
                >
                  {this.state.dropdownLanguage ? (
                    <img
                      src={SvgHeaderNavigationClose}
                      className="svg-dropdown svg-change-language"
                      alt="Dropdown"
                    />
                  ) : (
                    <img
                      src={SvgChangeLanguage}
                      className="svg-dropdown svg-change-language"
                      alt="Dropdown"
                    />
                  )}
                </Button>

                <Button
                  onClick={() => {
                    this.setState({
                      dropdownLanguage: false,
                      dropdown: !this.state.dropdown,
                    });
                  }}
                >
                  {this.state.dropdown ? (
                    <img
                      src={SvgHeaderNavigationClose}
                      className="svg-dropdown"
                      alt="Dropdown"
                    />
                  ) : (
                    <img
                      src={SvgHeaderNavigation}
                      className="svg-dropdown"
                      alt="Dropdown"
                    />
                  )}
                </Button>
              </Col>
            </Row>
          </Container>
        </div>
        <div className="body-contact">
          <h4>{language.imprint.header}</h4>
          <article>
            <h6>{language.imprint.article[0].header}</h6>
            <p>{language.imprint.article[0].content1}</p>
          </article>
          <article>
            <h6>{language.imprint.article[1].header}</h6>
            <p>{language.imprint.article[1].content1}</p>
          </article>
          <article>
            <p>{language.imprint.article[1].content2}</p>
          </article>
          <article>
            <h6>{language.imprint.article[2].header}</h6>
            <p>{language.imprint.article[2].content1}</p>
          </article>
          <article>
            <h6>{language.imprint.article[3].header}</h6>
            <p>{language.imprint.article[3].content1}</p>
          </article>
          <article>
            <h6>{language.imprint.article[4].header}</h6>
            <p>{language.imprint.article[4].content1}</p>
          </article>
          <article>
            <h6 className="listening">{language.imprint.article[5].header}</h6>
            <p>{language.imprint.article[5].content1}</p>
          </article>
          <article>
            <h6 className="listening">{language.imprint.article[6].header}</h6>
            <p>{language.imprint.article[6].content1}</p>
          </article>
          <article>
            <h6 className="listening">{language.imprint.article[7].header}</h6>
            <p>{language.imprint.article[7].content1}</p>
          </article>
        </div>
      </>
    );
  }
}

export default Imprint;
